import { List, Text } from "@mantine/core";

import { UpdateList } from "../components/UpdateList";
import { WhatsNewUpdate } from "../update";

export const update20240104: WhatsNewUpdate = {
  id: "322A9FD7-8BBD-455A-B6AF-B5D31BE3FE89",
  date: "2024-01-04",
  subject: "New templates: IniBuilds A300, Aerosoft CRJ, and a handful of other addons",
  content: (
    <>
      <Text pb="sm">
        New templates! As of today, fs-checklist-studio now has a starter template for the IniBuilds
        A300 and the Aerosoft CRJ, as well as addon templates for:
      </Text>
      <UpdateList>
        <List.Item>FSLTL</List.Item>
        <List.Item>VATSIM</List.Item>
        <List.Item>A Pilot's Life</List.Item>
        <List.Item>Self-Loading Cargo</List.Item>
        <List.Item>FS2Crew</List.Item>
        <List.Item>PACX</List.Item>
      </UpdateList>
    </>
  ),
};
